import "./Addproperties.css";
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";


const Addproperties = () => {
  const [inputs, setInputs] = useState({});
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([])
  const [base64Images, setBase64Images] = useState([]);
  const navigate = useNavigate();


  const handleChange = (e) => {
    setInputs((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };


  const handleFileChange = async (e) => {
  const files = Array.from(e.target.files); 
 setSelectedFiles(files);

  const promises = files.map((file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result); // full base64 string
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  });

  try {
    const base64Results = await Promise.all(promises);
    setBase64Images(base64Results);
  } catch (error) {
    console.error("Error reading files", error);
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const payload = {
      title: inputs.title || "",
      price: inputs.price || "",
      address: inputs.address || "",
      city: inputs.city || "",
      bathroomNumber: parseInt(inputs.bathroomNumber || 0),
      bedroomNumber: parseInt(inputs.bedroomNumber || 0),
      licenseNumber: inputs.licenseNumber || "",
      propertyCode: inputs.propertyCode || "",
      type: inputs.type || "",
      propertyType: inputs.propertyType || "",
      utilitiesPolicy: inputs.utilitiesPolicy || "",
      petPolicy: inputs.petPolicy || "",
      incomePolicy: inputs.incomePolicy || "",
      propertySize: inputs.propertySize || "",
      description: value || "",
      image: base64Images,
    };
  
    try {
      const res = await axios.post(
        "https://baseapis.akari.sa/api/Property/AddProperty",
        payload
      );
    
      console.log("API response:", res.data.id);
    
      // Navigate to property list page instead of single page
      navigate("/propertylist");
    } catch (err) {
      const errorData = err.response?.data;
      if (errorData?.errors) {
        const errorMessages = Object.entries(errorData.errors)
          .map(([key, val]) => `${key}: ${val.join(", ")}`)
          .join("\n");
        setError(`Validation Error:\n${errorMessages}`);
      } else {
        setError("Failed to submit. Please check all fields.");
      }
    }
    
  };

   
  

  return (
    <div className="newPostPage">
      <div className="formContainer">
        <h1>Add New Property</h1>
        <div className="wrapper">
          <form onSubmit={handleSubmit}>
            {[
              { label: "Title", name: "title", type: "text" },
              { label: "Price", name: "price", type: "text" },
              { label: "Address", name: "address", type: "text" },
              { label: "City", name: "city", type: "text" },
              { label: "Bedroom Number", name: "bedroomNumber", type: "number" },
              { label: "Bathroom Number", name: "bathroomNumber", type: "number" },
              { label: "License Number", name: "licenseNumber", type: "text" },
              { label: "Property Code", name: "propertyCode", type: "text" },
              { label: "Property facade", name: "incomePolicy", type: "text" },
              { label: "Property Size", name: "propertySize", type: "text" },
            ].map(({ label, name, type }) => (
              <div className="item" key={name}>
                <label htmlFor={name}>{label}</label>
                <input
                  id={name}
                  name={name}
                  type={type}
                  onChange={handleChange}
                />
              </div>
            ))}

            
            {[
              {
                label: "Type",
                name: "type",
                options: ["rent", "sale"],
              },
              {
                label: "Property Type",
                name: "propertyType",
                options: ["apartment", "house", "villa", "land","hotel","tower","commercial"],
              },
              {
                label: "Property age",
                name: "utilitiesPolicy",
                options: ["new", "Less than a year", "one year","Two years","Three years","Four years","Five years","six years","seven years"],
              },
              {
                label: "Pet Policy",
                name: "petPolicy",
                options: ["allowed", "not-allowed"],
              },
            ].map(({ label, name, options }) => (
              <div className="item" key={name}>
                <label htmlFor={name}>{label}</label>
                <select name={name} onChange={handleChange}>
                  {options.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            ))}

           
            <div className="item description">
              <label htmlFor="desc">Description</label>
              <textarea
                id="desc"
                className="description-textarea"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                rows="4"
                placeholder="Enter description here..."
              />
            </div>

            
          <div className="item">
              <label htmlFor="image">Upload Image</label>
              <input
                type="file"
                id="image"
                accept="image/*"
                multiple
                onChange={handleFileChange}
              />
            </div>

            <button className="sendButton" type="submit">
              Add
            </button>
            {error && <span className="errorMessage">{error}</span>}
          </form>
        </div>
      </div>
     <div className="sideContainer">
  {base64Images.length > 0 ? (
    base64Images.map((src, index) => (
      <img
        key={index}
        src={src}
        alt={`Preview ${index}`}
        style={{ maxWidth: "100px", marginRight: "10px", marginBottom: "10px" }}
      />
    ))
  ) : (
    <p>No images selected</p>
  )}
</div>

    </div> 
  );
};

export default Addproperties;


